export default function AlgoliaHorizontalHit({ hit }) {
  return (
    <div className="wrapper--outside mb-3xl sm:border-t sm:border-grey-light">
      <article className="group wrapper wrapper--max grid grid-cols-3 max-md:grid-cols-1">
        <div>
          <div className="grid grid-cols-[var(--spacing-xl)_1fr] gap-lg max-lg:grid-cols-1">
            <span className="text-[44px] text--vertical hidden lg:block font-thin">
              {hit?.default_genre ? hit.default_genre : 'Event'}
            </span>

            {hit?.images?.grid_image && hit?.post_title && hit?.permalink ? (
              <a href={hit?.permalink}>
                <div className="overflow-hidden">
                  <img
                    src={hit.images.grid_image}
                    className="object-cover aspect-video w-full wp-post-image  group-hover:scale-105 transition-all duration-250"
                    alt={hit.post_title}
                    decoding="async"
                    loading="lazy"
                  />
                </div>
              </a>
            ) : (
              <a href={hit?.permalink}>
                <img
                  src="/wp-content/themes/jersey-opera-house/dist/img/grid-item-placeholder.png"
                  alt="Placeholder"
                />
              </a>
            )}
          </div>
        </div>

        <div className="text--theme theme--text-sm border-0">
          {hit?.default_genre ? (
            <span className="text-[28px] hidden max-lg:block text-gold font-secondary mt-md">
              {hit.default_genre}
            </span>
          ) : null}

          {hit?.post_title && hit?.permalink ? (
            <h3 className="text--stretch">
              <a
                href={hit?.permalink}
                className="hover:text-gold group-hover:text-gold duration-200 leading-none !no-underline">
                {hit.post_title}
              </a>
            </h3>
          ) : null}

          {hit?.description ? (
            <div dangerouslySetInnerHTML={{ __html: hit.description }} />
          ) : null}
        </div>

        <div className="text--theme theme--text-sm">
          <div className="flex max-xl:flex-col max-md:flex-row max-sm:flex-col gap-md justify-between">
            <p className="block p--lg leading-tight">
              {hit?.event_dates?.start_date ? (
                <strong>{hit.event_dates?.start_date}</strong>
              ) : null}{' '}
              {hit?.event_dates?.end_date &&
              hit?.event_dates?.start_date !== hit?.event_dates?.end_date ? (
                <strong> - {hit.event_dates?.end_date}</strong>
              ) : null}{' '}
              <br />
              {hit?.venue ? (
                <span className="block mt-2xs">{hit?.venue}</span>
              ) : null}
            </p>

            <nav className="flex items-center flex-col max-md:flex-row max-xs:flex-col gap-sm">
              {hit.booking_url ? (
                <a
                  href={hit.booking_url}
                  className="btn btn--sm btn--solid py-sm px-lg w-full whitespace-nowrap"
                  target="_blank"
                  rel="noopener noreferrer">
                  Book Now
                </a>
              ) : null}

              {hit?.permalink ? (
                <a
                  href={hit?.permalink}
                  className="btn btn--sm btn--outline py-sm px-lg w-full whitespace-nowrap">
                  More Info
                </a>
              ) : null}
            </nav>
          </div>
        </div>
      </article>
    </div>
  )
}
